import React from "react";

import classNames from "classnames";
import parse from "html-react-parser";
import { Col, Container, Row } from "react-bootstrap";

import { store } from "../../..";
import "../../../assets/css/umphub/pages/home.scss";
import umphubta from "../../../assets/images/UmpHub-Training-Academy.png";
import umpire1 from "../../../assets/images/ump1.jpg";
import umpire2 from "../../../assets/images/ump2.jpg";
import youresafe from "../../../assets/images/Youre-Safe-Logo-1.png";
import {
    globalActions,
    selectSetting,
} from "../../../features/global/globalSlice";
import { useAppSelector } from "../../../hooks/reduxHooks";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { isXOrBigger, isXOrSmaller } from "../../../lib/utils";

export const loader = async () => {
    const { settings } = store.getState().global;
    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    await Promise.all(promises);

    return null;
};

const HomePage = (): React.JSX.Element => {
    const breakpoint = useBreakpoint();
    const upperContent = useAppSelector(state =>
        selectSetting(state, "umphub_upper_section_content"),
    );
    const lowerContent = useAppSelector(state =>
        selectSetting(state, "umphub_lower_section_content"),
    );

    return (
        <Container
            data-testid="homePageContent"
            className={classNames("homePage")}
        >
            <Row>
                <Col className={classNames("col")} lg={6} xs={12}>
                    <img src={umpire1} alt="UmpHub.net" />
                </Col>
                <Col className={classNames("col")} lg={6} xs={12}>
                    <img
                        src={youresafe}
                        alt="Certified You're Safe Umpires"
                        className={classNames("youresafelogo", "float-end")}
                    />
                    <div>{parse(upperContent?.setting)}</div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <img
                        src={umphubta}
                        alt="UmpHub Training Academy Logo"
                        className={classNames({
                            "w-50": isXOrSmaller("md", breakpoint),
                            "w-25": isXOrBigger("lg", breakpoint),
                        })}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <img
                        src={umpire2}
                        alt="UmpHub Training Academy"
                        className={classNames("float-end", "uhta")}
                    />
                    <div>{parse(lowerContent?.setting)}</div>
                </Col>
            </Row>
        </Container>
    );
};

export default HomePage;
